import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["section"]
  static values = {
    url: String
  }

  connect() {
    this.initDragAndDrop()
  }

  initDragAndDrop() {
    this.sectionTargets.forEach(section => {
      const handle = section.querySelector("[data-drag-handle]")
      const draggable = handle || section

      section.setAttribute("draggable", "true")
      draggable.addEventListener("dragstart", (e) => this.dragStart(e, section))
      section.addEventListener("dragover", this.dragOver.bind(this))
      section.addEventListener("drop", this.drop.bind(this))
      section.addEventListener("dragend", (e) => this.dragEnd(e, section))
    })
  }

  dragStart(event, section) {
    this.draggedElement = section
    section.classList.add("opacity-50")
    event.dataTransfer.effectAllowed = "move"
  }

  dragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const target = event.currentTarget
    if (target === this.draggedElement) return

    const rect = target.getBoundingClientRect()
    const midY = rect.top + rect.height / 2

    if (event.clientY < midY) {
      target.parentNode.insertBefore(this.draggedElement, target)
    } else {
      target.parentNode.insertBefore(this.draggedElement, target.nextSibling)
    }
  }

  drop(event) {
    event.preventDefault()
  }

  dragEnd(event, section) {
    section.classList.remove("opacity-50")
    this.saveOrder()
  }

  saveOrder() {
    if (!this.urlValue) return

    const orderedIds = this.sectionTargets.map(s => s.dataset.sectionId)
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "Accept": "application/json"
      },
      body: JSON.stringify({ ordered_ids: orderedIds })
    })
  }
}
